import { render, staticRenderFns } from "./Butterfly.vue?vue&type=template&id=3ce3a037&scoped=true"
import script from "./Butterfly.vue?vue&type=script&lang=js"
export * from "./Butterfly.vue?vue&type=script&lang=js"
import style0 from "./Butterfly.vue?vue&type=style&index=0&id=3ce3a037&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce3a037",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ce3a037')) {
      api.createRecord('3ce3a037', component.options)
    } else {
      api.reload('3ce3a037', component.options)
    }
    module.hot.accept("./Butterfly.vue?vue&type=template&id=3ce3a037&scoped=true", function () {
      api.rerender('3ce3a037', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Butterfly/Butterfly.vue"
export default component.exports